import { injectable } from "inversify";
import UserRepository from "../../repositories/UserRepository";
import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../entities/ExceptionEntity";
import { ProvisionUserPayload, ProvisionUserResponse } from "../../entities/ProvisionUserEntity";

interface props { userRepository: UserRepository }

@injectable()
export default class ProvisionUserUseCase {
    _userRepository: UserRepository;

    constructor(_: props) {
        this._userRepository = _.userRepository;
    }

    public call = async (data: ProvisionUserPayload) => new Promise<Either<ExceptionEntity, ProvisionUserResponse>>(async (resolve, reject) => {
        try {
            const response = await this._userRepository.provisionUser(data);
            return resolve(response);
        } catch (error) {
            return reject();
        }
    });
}

export const ProvisionUserUseCaseName = "ProvisionUserUseCaseName";
